import { render, staticRenderFns } from "./SiderContent.vue?vue&type=template&id=678fadc4&scoped=true&"
import script from "./SiderContent.vue?vue&type=script&lang=js&"
export * from "./SiderContent.vue?vue&type=script&lang=js&"
import style0 from "./SiderContent.vue?vue&type=style&index=0&id=678fadc4&scoped=true&lang=scss&"
import style1 from "./SiderContent.vue?vue&type=style&index=1&id=678fadc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fadc4",
  null
  
)

export default component.exports